import React, { Component } from 'react';
import classes from "./Chart_Village_Person_Board.module.css";
import Chart_Village_Person_BarChart from './Chart_Village_Person_BarChart';

export default class Chart_Village_Person_Board extends Component {

    render() {
        return (
            <div className={classes.container}>
            <p>Animal Crossing has close to 400 Villagers, and their personalities range from Cranky to Normal to Snooty as shown below. There are more Lazy personality types (60 Villagers) than 24 Sisterly villagers. Also, Sisterly villagers are rare, so it is best to encourage them to stay on your island.</p>              
                <Chart_Village_Person_BarChart />    
            </div>
        )
    }
}

/* Tutorial from:
     https://blog.bitsrc.io/customizing-chart-js-in-react-2199fa81530a
*/